import React from "react";
import "swiper/css";
import "./sliderSwiper.css";
import { Autoplay } from "swiper/modules";
import styles from "./slider.module.css";
import { Col, Row } from "react-bootstrap";
import { MdArrowOutward } from "react-icons/md";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";

export default function SwiperSlider() {
  const myData = [
    {
      title: "Natural Resources",
      subtitle: "Powering Industries with Premium Resources",
      description:
        "From coal and iron ore to precious metals and solar energy, our natural resources fuel industries across the globe with reliability and efficiency.",
      imageUrl: "images/card/img_1.png",
    },
    {
      title: "Food and Agriculture",
      subtitle: "Powering Industries with Premium Resources",
      description:
        "Offering high-quality teas, coffees, spices, and fertilizers to sustain and enrich global communities.",
      imageUrl: "images/card/img_22.png",
    },
    {
      title: "Luxury and Essentials",
      subtitle: "Everyday Essentials to Luxury Indulgence",
      description:
        "From body care products to luxury brands, we cater to diverse lifestyles with uncompromising quality.",
      imageUrl: "images/card/img_3.png",
    },
    {
      title: "Sustainability Services",
      subtitle: "Shaping a Sustainable Future",
      description:
        "Explore our solar energy solutions, clean water distribution systems, and green initiatives for a better tomorrow.",
      imageUrl: "images/card/img_4.png",
    },
  ];

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product`);
  };

  return (
    <Swiper
      slidesPerView={1.5}
      spaceBetween={40}
      modules={[Autoplay]}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
      }}
      className="mySwiper mb-4"
      breakpoints={{
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 1.5,
          spaceBetween: 40,
        },
      }}
    >
      {myData.map((item, index) => (
        <SwiperSlide key={index}>
          <div className={styles.slider_box}>
            <div className={styles.card} onClick={handleClick}>
              <Row>
                <Col md={7}>
                  <div className={styles.left}>
                    <h1>{item.title}</h1>
                    <MdArrowOutward className="text-white" size={40} />
                    <h2>{item.subtitle}</h2>
                    <p>{item.description}</p>
                  </div>
                </Col>
                <Col md={5}>
                  <div
                    style={{
                      backgroundImage: `url(${item.imageUrl})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "cover",
                      height: "350px",
                      margin: 0,
                      padding: 0,
                    }}
                  ></div>
                </Col>
              </Row>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
